import styled from '@emotion/styled';
import { Box, Card } from '@mui/material';
import { Center, Column, Row } from '../../../styles';
import { shouldForwardProps } from '../../../utils';
import { Breakpoint, getBreakpointValue, isExpanded } from '../../../types';
import { DigitalhubDivider } from '../../../components';

const Banner = styled(Column, shouldForwardProps)`
    background: ${({ theme }) =>
        `linear-gradient(180deg, ${theme.colors.primary15} 0%,  ${theme.colors.primaryContainerDark} 100%)`};
`;

const BannerGridRow = styled(Row)`
    width: 100%;
`;

const LandingPageSection = styled(Column, shouldForwardProps)<{ breakpoint: Breakpoint }>`
    max-width: 1128px;
    align-self: center;
    width: calc(100% - 48px);
    margin-left: ${({ breakpoint }) => getBreakpointValue(breakpoint, '16px', '24px', '24px')};
    margin-right: ${({ breakpoint }) => getBreakpointValue(breakpoint, '16px', '24px', '24px')};
`;

const MatchingSection = styled(Column, shouldForwardProps)<{ breakpoint: Breakpoint }>`
    align-self: center;
    width: 100%;
    background-color: ${({ theme }) => theme.colors.onPrimaryDark};
`;

const LandingPageCardContainer = styled(Box, shouldForwardProps)<{
    isExpanded: boolean;
}>`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: stretch;
    gap: ${({ theme }) => theme.spacing(3)};
    margin-bottom: ${({ theme }) => theme.spacing(3)};
`;

const LandingPageRoleCard = styled(Card, shouldForwardProps)`
    height: auto;
    width: 360px;
    margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

const LandingPageContent = styled(Center, shouldForwardProps)`
    position: relative;
    width: 100%;
    gap: ${({ theme }) => theme.spacing(5)};
    padding: ${({ theme }) => `${theme.spacing(4)} ${theme.spacing(6)}`};
`;

const BottomSectionContainer = styled(Box)`
    background-image: ${({ theme }) =>
        `linear-gradient(-10deg, #fff 50%, ${theme.colors.onPrimaryDark} 0%)`};
    min-height: 500px;
    align-self: anchor-center;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const BannerRow = styled(Row, shouldForwardProps)<{ breakpoint: Breakpoint }>`
    display: grid;
    grid-template-columns: ${({ breakpoint }) =>
        isExpanded(breakpoint) ? '1fr 1px 3fr 1px 1fr' : '1fr'};
    width: 100%;
    height: ${({ breakpoint }) => (isExpanded(breakpoint) ? 'auto' : '65%')};
`;

const BannerBox = styled(Box, shouldForwardProps)<{ breakpoint: Breakpoint }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    align-items: center;
    padding-top: ${({ theme }) => theme.spacing(5)};
`;

const DashboardFooterContainer = styled(Box, shouldForwardProps)`
    position: relative;
    padding-top: ${({ theme }) => theme.spacing(6)};
    overflow-x: clip;
`;

const DiagonalDivider = styled(DigitalhubDivider, shouldForwardProps)`
    position: absolute;
    top: 0;
    left: -15px;
    width: 100vw;
    height: 2px;
    transform: rotate(-10deg);
    transform-origin: 64vw center;
    margin: 0;
`;

const DashboardFooterLogoContainer = styled(Box, shouldForwardProps)`
    max-width: 731px;
    width: 100%;
    margin-left: auto;
    margin-right: 0;
    position: relative;
    padding: ${({ theme }) => theme.spacing(2)};
    display: flex;
    justify-content: space-evenly;
    align-items: center;
`;

export {
    LandingPageSection,
    LandingPageContent,
    LandingPageCardContainer,
    LandingPageRoleCard,
    Banner,
    MatchingSection,
    BannerGridRow,
    BottomSectionContainer,
    BannerRow,
    BannerBox,
    DashboardFooterContainer,
    DiagonalDivider,
    DashboardFooterLogoContainer
};
